export default [
  {
    path: '/login',
    component: () => import('src/layouts/EmptyLayout'),
    props: { backgroundImage: 'images/login-background.jpg' },
    meta: { requiresGuest: true },
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('./containers/LoginContainer'),
      },
    ],
  },
]
